import React from "react";

const Method = ({
  icon,
  title,
  onClick,
  disabled = false,
  description = null,
}) => {
  return (
    <div
      onClick={!disabled ? onClick : undefined}
      className={`w-full h-auto p-3 rounded-xl bg-gray-600 flex flex-col gap-2 
        transition-shadow duration-300 ease-in-out shadow-[0_0_10px_rgba(34,197,94,0.3)]
        ${
          disabled
            ? "opacity-30 cursor-not-allowed"
            : "cursor-pointer hover:shadow-[0_0_10px_rgba(34,197,94,0.3)]"
        }`}
    >
      <div className="flex items-start">{icon}</div>

      <span className="text-sm text-gray-200 leading-snug">{title}</span>

      {description && (
        <span
          className="text-xs text-gray-200 leading-tight"
          style={{ marginTop: -5 }}
        >
          {description}
        </span>
      )}
    </div>
  );
};

export default Method;
